var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import OpenTicketBase from '../internals/base';
import { ApiError, ShopError } from '../internals/errors';
import { OrderConfig } from './config';
import CrossWindowOrder from './messaging';
/**
 *  Used to create a new order instance that holds all the data of the order.
 */
export default class OpenTicketOrder extends OpenTicketBase {
    constructor() {
        super(...arguments);
        this._eventScope = 'order';
        // All relational data
        this.tickets = [];
        this.products = [];
        this.payments = [];
        this.metadata = [];
    }
    /**
     * Get data from the API and parse data to class properties
     * @param config - The configuration object for the order
     * @param data - If provided, this data will be used and no API call will be executed
     */
    init(config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.is_initialized) {
                throw new ShopError('Order already initialized');
            }
            this._config = new OrderConfig(config);
            const basePromise = this.initBase(config);
            try {
                const orderData = yield this._getOrderData();
                this._setData(orderData);
                yield basePromise;
                // Check if this window is embedded
                if (window.self !== window.top) {
                    // Setup messaging
                    this.messaging = new CrossWindowOrder(window.parent, this);
                }
                this._resolveInit(true);
                this.is_initialized = true;
                return true;
            }
            catch (error) {
                yield basePromise;
                this._rejectInit(error);
            }
            finally {
                this.loading = false;
            }
            return false;
        });
    }
    /**
     *  Receive order data from the API
     *
     * @todo
     */
    _getOrderData() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this._config.getUrl(`${this._config.guid}`);
            try {
                const shop = yield this._config.httpClient.get(url);
                return shop.data;
            }
            catch (error) {
                throw new ApiError(error);
            }
        });
    }
    /**
     *  Transform and set data to class properties
     *
     * @todo
     */
    _setData(orderData) {
        this.data = orderData;
    }
}
//# sourceMappingURL=order.js.map